import type { RiskFactor as RiskFactorModel } from '@/adapters/catalogv1.g';

export function extractRiskFactor(model: RiskFactorModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.risk_factor_ref ?? '',
    name: model.name ?? '',
    description: model.description ?? '',
    category: model.category ?? '',
    weight: model.weight,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogRiskFactor = ReturnType<typeof extractRiskFactor>;
